import React, { useEffect } from 'react';
import Lottie from 'react-lottie';
import './Whatsapp_Lottie.css';
import * as animationData from './Whatsapp_Lottie.json';
import { useDispatch, useSelector } from 'react-redux';
import { AllAppsetup } from '../../../features/admin/footer/Slice';

function Whatsapp_Lottie() {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  };

  const dispatch = useDispatch();

  const app_setup = useSelector((state) => state.footer.app_setup);


  useEffect(() => {
    dispatch(AllAppsetup());
  }, [dispatch]);

  return (
    <section
      className='main'
      onClick={() => window.open(`https://wa.me/${app_setup?.contact_no}`, "_blank")}
      style={{ cursor: "pointer" }}
    >
      <div className="Whatsapp_Lottie_icon_holder">
        <div className='Whatsapp_Lottie_icon'>
          <Lottie
            className="me-auto"
            options={defaultOptions}
          />
        </div>
        <p>Ask Tapovan</p>
      </div>
    </section>

  );
}
export default Whatsapp_Lottie;